import React from 'react';
import { Alert, AlertTitle, Box } from '@availity/element';

const NonProdBanner = () => (
  <Alert severity="warning" sx={{ padding: 2, maxWidth: '1267px' }}>
    <AlertTitle>Warning!</AlertTitle>
    <Box>
      This is a non-production test environment. Please do not place any PHI in this environment. You assume any and all
      risk associated with PHI you place in this environment.
    </Box>
  </Alert>
);

export default NonProdBanner;
